import React from 'react'

const SignIn = () => {
  return (
    <h1>SignIn</h1>
  )
}

export default SignIn